export const generateStringOfN = (length: number, char: string = "0") => new Array(length + 1).join(char)